import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { ApiResponse } from '../types/notifications';

export const getNotifications = withLogger(async () => {
  const { data } = await authServiceAxiosClient.get<ApiResponse>(
    '/settings/recent-notifications',
  );

  return data.data.data ?? [];
});
